<template>
      <section class="clientele">
		<van-tabbar v-model="active" @change="changeTabbar" active-color="#4C535D" inactive-color="#4C535D">
			<van-tabbar-item>
				<span>抢单</span>
				<template #icon="props">
					<img :src="props.active ? orderAIcon : orderIcon" />
				</template>
			</van-tabbar-item>
			<van-tabbar-item>
				<span>客户</span>
				<template #icon="props">
					<img :src="props.active ? customerAIcon : customerIcon" />
				</template>
			</van-tabbar-item>
			<van-tabbar-item>
				<span>我的</span>
				<template #icon="props">
					<img :src="props.active ?myAIcon : myIcon" />
				</template>
			</van-tabbar-item>
		</van-tabbar>
		<section class="top_c">
			<div class="left">
				<p :class="{'active': activec}" @click="getOrder(1)">已接单</p>
				<p :class="{'active': !activec}" @click="getOrder(0)">退单</p>
			</div>
			<!-- <div class="right">
				筛选
				<img src="../../assets/img/allow_down.png" />
			</div> -->
		</section>
		<section v-if="isData==2"></section>
		<section v-else-if="isData==1">
			<h4 v-if="Txt">{{Txt}}</h4>
			<van-list v-model="loading" @load="loadMore" :immediate-check="false"  class="list" :finished="finished" finished-text="">
				<van-cell class="item" v-for="item in list" :key="item.id" @click="skipOrderInfo(item.orderId)">
					<div class="top">
						<p>
							<span>{{item.require.cusDetail.basicInfo.name}}</span>
							<!-- <img src="../../assets/img/star45.png" /> -->
						</p>
						<!-- <i v-if="activec == 1">{{item.createTime}}</i> -->
						<div>
							<img src="../../assets/img/list_icon.png">
							{{item.cityStr}}
						</div>
					</div>
					<div class="middle">
						<div class="num">
							<p>{{item.require.loanAmount/baseNum}}<span>万</span></p>
							<p>{{item.require.loanTerm}}<span>个月</span></p>
						</div>
						<div class="tag">
							<span v-for="item in item.require.cusDetail.tag" :key="item.id">{{item.name}}</span>
							<!-- <span v-if="item.require.cusDetail.workInfo.socialStatus==1">社保</span>
							<span v-if="item.require.cusDetail.workInfo.fundStatus==1">公积金</span>
							<span v-if="item.require.cusDetail.assetInfo.houseStatus==1">房产</span>
							<span v-if="item.require.cusDetail.assetInfo.carStatus==1">车产</span>
							<span v-if="item.require.cusDetail.assetInfo.insuranceStatus==1">保险</span>
							<span v-if="item.require.cusDetail.assetInfo.licenseStatus==1">执照</span> -->
						</div>
					</div>
					<div class="bottom">
						<van-button type="primary" @click="skipOrderInfo(item.orderId)" v-if="activec">
							<img src="../../assets/img/ok.png" />
							已接单
						</van-button>
						<van-button type="primary" @click="skipOrderInfo(item.orderId)" v-else class="quit">
							<p v-if="item.status == 0">
								<img src="../../assets/img/no.png" />
								退单中
							</p>
							<p v-else-if="item.status == 20">
								<img src="../../assets/img/quit_1.png" />
								已退单
							</p>
							<p v-else-if="item.status == 30">
								<img src="../../assets/img/quit_0.png" />
								退单失败
							</p>
						</van-button>
					</div>
				</van-cell>
			</van-list>
		</section>
		<section v-else class="nodata_class">
			<h4 v-if="Txt">{{Txt}}</h4>
			<div v-if="activec" class="client_no">
				<img src="../../assets/img/client_no.png">
				<p>暂无已接单记录，快去抢单吧</p>
			</div>
			<div v-else class="no_data">
				<img src="../../assets/img/no_data.png">
				<p>暂无记录</p>
			</div>
		</section>
    </section>
</template>

<script>
import clienteleServer from "api/clientele";
import customerIcon from "assets/img/customer.png"
import customerAIcon from "assets/img/customer_a.png"
import orderIcon from "assets/img/order.png"
import orderAIcon from "assets/img/order_a.png"
import myIcon from "assets/img/my.png"
import myAIcon from "assets/img/my_a.png"
export default {
	name: 'clientele',
    data() {
        return {
			customerIcon,
			customerAIcon,
			customerAIcon,
			orderIcon,
			orderAIcon,
			myIcon,
			myAIcon,
			isData: 2,
			token: '',
			active: 1,
			list: [],
			loading: false,
      		finished: false,
			baseNum: 1000000,
			params: {
				pageNum: 0,
				pageSize: 10,
			},
			activec: 1,
			Txt: '',
        };
    },
    created() {
		this.token = localStorage.getItem('token')
		this.activec = localStorage.getItem('activec') == null?1: Number(localStorage.getItem('activec'))
		if(this.token) {
			this.getTxt()
			this.loadMore()
		}else {
			this.isData =3
		}
	},
		mounted() {
		if(this.$store.state.clientType==2) {
			document.addEventListener('plusready', function() { 
				var webview = plus.webview.currentWebview(); 
				plus.key.addEventListener('backbutton', function() {
					webview.canBack(function(e) {
						if(e.canBack) {
							webview.back()
						}else {
							webview.close();
						}
					})
				})
			}) 
		}
	},
    methods: {
		getTxt() {
			clienteleServer.SearchTxt().then((res) => {
				this.Txt=res.data
			})
		},
		changeTabbar() {
			if(this.active == 0) {
				this.$router.push({ name: 'index'})
			}else if(this.active == 2) {
				this.$router.push({ name: 'user'})
			}
		},
		loadMore() {
			//已接单
			let reqFn = ''
			if(this.activec) {
				reqFn = clienteleServer.SearchClienteleBuy
			}else {
				reqFn = clienteleServer.SearchClienteleQuit
			}
			this.loading = true
			this.params.pageNum++
			reqFn(this.params).then((res) => {
				if(this.params.pageNum == 1) {
					if(!res.data.list || res.data.list.length==0) {
						this.list = []
						this.isData = 3
						return
					}
				}
				if(this.activec) {
					res.data.list.forEach((item) => {
						item.createTime = this.createTimeInit(item.createTime)
					})
				}
				res.data.list.forEach((item) => {
					if(item.require.cusDetail.workInfo.city) {
						if(item.require.cusDetail.workInfo.city.indexOf('-')!=-1) {
							let city = item.require.cusDetail.workInfo.city.split('-')
							item.cityStr = this.longCityInit(city[1])
						}else {
							item.cityStr = this.longCityInit(item.require.cusDetail.workInfo.city)
						}
					}
					item.require.cusDetail.tag = []
					this.tagInit(item.require.cusDetail)
				})
				// longCityInit
				this.list = this.list.concat(res.data.list) 
				
				this.isData = 1
				this.loading = false
				if(res.data.list.length<10) {
					this.finished = true
				}
			})
		},
		tagInit(row) {
			if(row.workInfo.socialStatus ==1) {
				row.tag.push({
					id: 'socialStatus',
					name: '社保'
				})
			}
			if(row.workInfo.fundStatus ==1) {
				row.tag.push({
					id: 'fundStatus',
					name: '公积金'
				})
			}
			if(row.assetInfo.houseStatus ==1) {
				row.tag.push({
					id: 'houseStatus',
					name: '房产'
				})
			}
			if(row.assetInfo.licenseStatus ==1) {
				row.tag.push({
					id: 'licenseStatus',
					name: '执照'
				})
			}
			if(row.assetInfo.insuranceStatus ==1) {
				row.tag.push({
					id: 'insuranceStatus',
					name: '保险'
				})
			}
			if(row.assetInfo.carStatus ==1) {
				row.tag.push({
					id: 'carStatus',
					name: '车产'
				})
			}
			if(row.assetInfo.creditCardStatus ==1) {
				row.tag.push({
					id: 'creditCardStatus',
					name: '信用卡'
				})
			}
			if(row.assetInfo.jieBeiStatus ==1) {
				row.tag.push({
					id: 'jieBeiStatus',
					name: '借呗'
				})
			}
			if(row.assetInfo.particleLoanStatus ==1) {
				row.tag.push({
					id: 'particleLoanStatus',
					name: '微粒贷'
				})
			}
			if(row.assetInfo.sesameStatus ==1) {
				row.tag.push({
					id: 'sesameStatus',
					name: '芝麻分'
				})
			}
			if(row.tag.length>5) {
				row.tag = this.getRandomArrayElements(row.tag, 5)
			}
		},
		getRandomArrayElements(arr, count) {
			var shuffled = arr.slice(0), i = arr.length, min = i - count, temp, index;
			while (i-- > min) {
				index = Math.floor((i + 1) * Math.random());
				temp = shuffled[index];
				shuffled[index] = shuffled[i];
				shuffled[i] = temp;
			}
			return shuffled.slice(min);
		},




		getOrder(activec) {
			localStorage.setItem('activec', activec)
			this.params.pageNum = 0
			this.list = []
			this.activec = activec
			if(!this.token) return
			this.loadMore()
		},
        skipOrderInfo(id) {
			this.$router.push({name: 'clientInfo', params:{id: id}})
		},
		createTimeInit(time) {
			time = time.replace(/-/g,'/')
			let timeTxt = '',
				newTime = new Date(),
				timed =  new Date(time),
				s1 = newTime.getTime(),
				s2 = timed.getTime(),
				total = (s1 - s2)/1000,
				day = parseInt(total / (24*60*60)),//计算整数天数
				afterDay = total - day*24*60*60,//取得算出天数后剩余的秒数
				hour = parseInt(afterDay/(60*60)),//计算整数小时数
				afterHour = total - day*24*60*60 - hour*60*60,//取得算出小时数后剩余的秒数
				min = parseInt(afterHour/60),//计算整数分
				afterMin = total - day*24*60*60 - hour*60*60 - min*60;//取得算出分后剩余的秒数
			// 订单创建时间距现在小于1小时，展示1小时前；
			// 订单创建时间距现在小于24小时，展示xx小时前，xx为整数；
			// 订单创建时间距现在大于等于24小时，展示xx天前，xx为整数；  
			// 订单创建时间距现在大于等于7*24小时，统一展示7天前；
			
			if(day>=1) {
				timeTxt = day+'天前申请'
			}else {
				if(hour<24) {
					timeTxt = hour+'小时前申请'
				}
				if(hour<=1) {
					timeTxt = '1小时前申请'
				}
			}
			if(day>=7) {
				timeTxt = 7+'天前申请'
			}
			return timeTxt
		},
		longCityInit(str) {
			if(str.length>5) {
				let newSter = str.substr(0,2)+'...'+str.substr(-1,1)
				return newSter
			}else {
				return str
			}
		}
    },
};
</script>

<style lang="scss">
.clientele {
	padding-bottom: 80px;
	.van-tabbar--fixed {
			z-index: 9999;
			height: 48px;
		}
		.van-hairline--top-bottom::after, .van-hairline-unset--top-bottom::after {
			display: none;
		}
		.van-tabbar-item__icon {
			margin-bottom: 0;
			img {
				height: 28px;
			}
		}
	.top_c {
		position: fixed;
		top: 0;
		left: 0;
		z-index: 999;
		width: 100%;
		height: 60px;
		display: flex;
		align-items: center;
		justify-content: space-between;
		background: #fff;
		padding: 0 19px;
		.left {
			.active {
				font-size: 20px;
				font-weight: bold;
			}
			p {
				font-size: 16px;
				color: #2B2F3A;
				padding-right: 20px;
				display: inline-block;

			} 
			
		}
		.right {
			font-size: 16px;
			color: #2B2F3A;
			font-weight: bold;
			display: flex;
			align-items: center;
			img {
				width: 18px;
			}
		}

	}
	h4 {
		position: fixed;
		width: 100%;
		height: 28px;
		line-height: 28px;
		left: 0;
		top: 60px;
		font-size: 13px;
		color: #FD3A53;
		z-index: 999;
		padding: 0 18px;
		background: #FFEBEE;
	}
    .list {
		padding: 78px 18px;
		padding-bottom: 0;
        .item {
			position: relative;
			background: linear-gradient(180deg, #E6E9ED 0%, #FFFFFF 100%);
			height: 176px;
			padding: 0 14px;
			border-radius: 6px;
			line-height: normal;
			margin-bottom: 18px;
			overflow: initial;
			.van-cell__value {
				overflow: initial;
			}
            .sign {
                position: absolute;
                top: 9px;
                left: 0;
                width: 37px;
            }
            .top {
                display: flex;
                justify-content: space-between;
				align-items: center;
                padding-top: 8px;
                .example_p {
                    padding-left: 52px;
                }
                p {
					display: flex;
					justify-content: space-between;
					align-items: center;
                    span {
                        font-size: 14px;
                        color: #2c2d2f;
                    }
                    img {
                        width: 92px;
                        margin-left: 11px;
                    }
                }
                i {
                    font-size: 12px;
                    color: #a2a6ae;
                    font-style: normal;
                }
				div {
					display: flex;
					align-items: center;
					color: #7D8290;
					font-size: 12px;
					img {
						display: block;
						width: 10px;
						margin-right: 2px;
						margin-top: 1px;
					}
				}
            }
            .middle {
                text-align: center;
                padding-top: 15px;
                .num {
                    p {
                        font-size: 28px;
                        font-weight: bold;
                        color: #292d37;
                        display: inline-block;
                        &:first-of-type {
                            padding-right: 39px;
                        }
                        span {
                            font-size: 16px;
                            color: #2b2f3a;
                        }
                    }
                }
                .tag {
                    padding-top: 12px;
                    span {
                        display: inline-block;
                        padding: 1px 5px;
                        text-align: center;
                        color: #5d6d98;
                        border: 1px solid #6877a1;
                        font-size: 12px;
                        margin-right: 12px;
                        &:last-of-type {
                            margin-right: 0;
                        }
                    }
                }
            }
            .bottom {
                padding-top: 22px;
                .van-button--primary {
                    width: 100%;
                    height: 32px;
                    background: #3A5EEC;
                    border-radius: 4px;
                    border: 0;
                    font-size: 15px;
                    font-weight: bold;
                    color: #ffffff;
                }
				.quit {
					color: #575F72;
					background: linear-gradient(270deg, #B5BED7 0%, #EDF0F9 100%);
				}
				img {
					width: 16px;
					vertical-align: middle;
				}
            }
        }
    }
	.nodata_class {
		position: relative;
		.client_no, .no_data {
			position: fixed;
			top: 46%;
			left: 50%;
			transform: translate(-50%, -50%);
			img {
				width: 215px;
				display: block;
			}
			p {
				padding-top: 19px;
				color: #575E72;
				font-size: 16px;
				text-align: center;
			}
		}
		.no_data img {
			width: 93px;
			p {
				padding-top: 38px;
			}
		}
	}
}
</style>


// WEBPACK FOOTER //
// src/views/index/Clientele.vue